import *  as Yup from 'yup';

const SchemaValidTasks = Yup.object().shape({
    effectiveDuration : Yup.string().required('Merci de renseigner le temps passé'),
});

export default SchemaValidTasks;


